export default from './follow-user-button-mobile-secure';



// WEBPACK FOOTER //
// ./app/containers/follow-user-button-mobile-secure/index.js